import type { Entity } from "@backstage/catalog-model";

export const GITLAB_PROJECT_SLUG_ANNOTATION = "gitlab.com/project-slug";

export const getGitlabProjectSlug = (entity: Entity): string | undefined => {
  const slug = entity.metadata.annotations?.[GITLAB_PROJECT_SLUG_ANNOTATION];
  return slug?.trim() || undefined;
};

export const getGitlabProjectApiPath = (projectSlug: string): string =>
  `/api/proxy/gitlab/api/projects/${encodeURIComponent(projectSlug)}`;

export const getGitlabPipelinesApiPath = (projectSlug: string, perPage = 1): string =>
  `${getGitlabProjectApiPath(projectSlug)}/pipelines?per_page=${perPage}`;

export const getGitlabReadmeApiPath = (projectSlug: string, ref: string): string =>
  `${getGitlabProjectApiPath(projectSlug)}/repository/files/${encodeURIComponent(
    "README.md",
  )}/raw?ref=${encodeURIComponent(ref)}`;
